/**
 * Action Dependencies
 */
import http, {
    setAuthorizationHeader,
    removeAuthorizationHeader
} from '../../../services/HttpService'

import {
    setToken,
    removeToken,
    authenticate,
    validateToken,
    changePassword
} from '../../../services/AuthService'

/**
 * Attempt user login with provided credentials
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
const attemptLogin = ({ commit, dispatch }, credentials) => {
    commit('LOGIN')
    return authenticate(credentials)
        .then(token => {
            setToken(token)
            setAuthorizationHeader(token)
            commit('LOGIN_SUCCESS')
            return Promise.resolve(token)
        })
        .catch(err => {
            removeToken()
            commit('LOGIN_FAILURE')
            return Promise.reject(err.response.data)
        })
}

/**
 * Set up successful authentication context
 *
 * @param  {Function} options.commit
 * @param  {Object} response
 * @return {Promise}
 */
const handleSuccessfullLogin = ({ commit }, token) => {
    return new Promise((resolve, reject) => {
        window.localStorage.setItem('token', token)
        http.defaults.headers.common = {
            'Authorization': 'Bearer ' + token
        }
        commit('LOGIN_SUCCESS')
        resolve(token)
    })
}

/**
 * Handle a failed login
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const handleFailedLogin = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.localStorage.removeItem('token')
        commit('LOGIN_FAILURE')
    })
}

/**
 * Check existing JWT against the API
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const checkAuthentication = ({ commit, dispatch }) => {
    return validateToken()
        .then(res => {
            return new Promise((resolve, reject) => {
                setAuthorizationHeader()
                commit('LOGIN_SUCCESS')
                resolve(res)
            })
        })
        .catch(err => {
            return new Promise((resolve, reject) => {
                removeToken()
                removeAuthorizationHeader()
                reject(err)
            })
        })
}

/**
 * Process the log out action
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const logout = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.localStorage.removeItem('id_token')
        removeAuthorizationHeader()
        commit('LOGOUT')
        return resolve('logged out')
    })
}

/**
 * Retrieve the user profile
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const getUserProfile = ({ commit, dispatch }) => {
    commit('GET_USER_PROFILE')
    return http.get('auth/account-information/')
        .then(res => {
            return new Promise((resolve, reject) => {
                let payload = res.data
                let company = payload.company
                let preferences = payload.preferences
                let subscription = payload.subscription
                delete payload.company
                delete payload.subscription
                delete payload.preferences
                commit('SET_USER_PROFILE', payload)
                dispatch('company/setCompanyData', company, { root: true })
                dispatch('preferences/setPreferences', preferences)
                dispatch('subscription/setSubscription', subscription)
                resolve(res)
            })
        })
        .catch(err => {
            return new Promise((resolve, reject) => {
                commit('GET_USER_PROFILE_FAIL', err)
                reject(err)
            })
        })
}

/**
 * Update the user's password
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
const updatePassword = ({ commit }, payload) => {
    return changePassword(payload)
}

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Set the first run state variable
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const setFirstRun = ({ commit }) => commit('SET_FIRST_RUN')

/**
 * Reset the first run state variable
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetFirstRun = ({ commit }) => commit('RESET_FIRST_RUN')

export default {
    logout,
    resetState,
    setFirstRun,
    attemptLogin,
    resetFirstRun,
    updatePassword,
    getUserProfile,
    handleFailedLogin,
    checkAuthentication,
    handleSuccessfullLogin
}



// WEBPACK FOOTER //
// ./src/state/modules/user/actions.js